.card {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin-top: var(--tuna-spacing-1);
}

.personal {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

.text {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-primary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.avatars {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
}

.reverse {
  align-self: flex-start;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

/* Below 600px: actions become full-width buttons, avatars wrap (spec, Mobile) */
@media (max-width: 599.95px) {
  .actions {
    flex-direction: column;
  }

  .actions > * {
    width: 100%;
  }
}
